import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Sección de la home que presenta la línea de bodas y enlaza a /bodas
// (enlace interno rastreable) y al configurador con tipo Novios.
export function BodasTeaser({ onDesign }: { onDesign: () => void }) {
  const { t } = useTranslation();
  return (
    <section id="bodas" className="py-20 bg-white" aria-labelledby="bodas-title">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-10 items-center max-w-5xl mx-auto">
          <img
            src="/seo/novios-traje-vestido-princesa.jpg"
            alt="Figura personalizada de novios: novio con traje azul marino y novia con vestido princesa, velo y ramo"
            width={800}
            height={800}
            loading="lazy"
            className="w-full max-w-sm mx-auto rounded-3xl shadow-elegant-lg"
          />
          <div>
            <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#866A12] mb-3">{t('home.weddingKicker')}</p>
            <h2 id="bodas-title" className="text-4xl font-semibold mb-4" style={{ color: 'var(--page-heading)' }}>{t('home.weddingTitle')}</h2>
            <p className="text-[#374151] leading-relaxed mb-6">{t('home.weddingText')}</p>
            {/* Tira de ejemplos: enseña de un vistazo que hay estilos y
                variantes (dos novios, mascota, bloques), no una sola figura. */}
            <div className="grid grid-cols-3 gap-2 mb-6 max-w-sm">
              {[
                { src: '/seo/novios-diorama-arco.jpg', alt: 'Figura de novios sobre un escenario con arco floral' },
                { src: '/seo/novios-diorama-playa.jpg', alt: 'Figura de novios de boda de playa con palmeras y su perro' },
                { src: '/seo/novios-chibi-arco.jpg', alt: 'Pareja de novios en estilo Chibi con arco de eucalipto' },
              ].map(img => (
                <img key={img.src} src={img.src} alt={img.alt} width={800} height={800} loading="lazy"
                  className="w-full h-auto rounded-xl bg-white shadow-elegant" />
              ))}
            </div>
            <div className="flex flex-wrap gap-3">
              <button type="button" onClick={onDesign} className="btn-nacre inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium">
                <Sparkles className="w-4 h-4" aria-hidden="true" /> {t('home.weddingCta')}
              </button>
              <a href="/bodas" className="inline-flex items-center px-6 py-3 rounded-full font-medium border border-[#D4AF37]/60 hover:bg-[#D4AF37]/10" style={{ color: 'var(--page-heading)' }}>
                {t('home.weddingMore')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
